import type { Role } from "@mn/shared";
import { createContext, useContext } from "react";
import type { BoardHandle } from "./collab";
import type { Interactions } from "./interactions";
import type { SpatialIndex } from "./spatial";

export interface BoardCtx {
  boardId: string;
  handle: BoardHandle;
  index: SpatialIndex;
  interactions: Interactions;
  role: Role;
  canEdit: boolean;
  user: { id: string; name: string; color: string; image: string | null };
  openBoard: (id: string) => void;
}
export const BoardContext = createContext<BoardCtx | null>(null);
export const useBoard = () => {
  const c = useContext(BoardContext);
  if (!c) throw new Error("BoardContext missing");
  return c;
};
